import {
  FormHelperText,
  Grid,
  InputLabel,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { CloudUpload, HelpOutline } from "@material-ui/icons";
import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import Dropzone from "react-dropzone";

// Contexts
import LayoutContext from "../../../context/layout/LayoutContext";
import CampaignContext from "../../../context/campaign/CampaignContext";

const useStyles = makeStyles((theme) => ({
  section: {
    marginTop: "0.1rem",
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "0.5rem",
  },
  skeleton: {
    borderRadius: "5px",
  },
  dropzone: {
    height: 150,
    width: "98%",
    margin: "0.5rem auto",
    border: "1px dashed lightgrey",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "darkgrey",
  },
  dropzoneHover: {
    "&:hover": {
      cursor: "pointer",
      color: "grey",
      backgroundColor: "rgba(220, 220, 220, 0.2)",
      borderWidth: 3,
    },
  },
  dropzoneError: {
    borderWidth: 2,
    borderColor: theme.palette.error.main,
  },
  image: {
    objectFit: "contain",
  },
}));

const Section_04 = () => {
  const classes = useStyles();

  const { form_data, setFormData } = useContext(CampaignContext);
  const { setAlert } = useContext(LayoutContext);
  const [logo, setLogo] = useState(form_data.store_logo);

  const handleChange = (e) => {
    const id = e.target.id;
    let value = e.target.value;
    form_data[id] = value;
    setFormData(form_data);
  };

  const onDrop = useCallback((acceptedFiles, id) => {
    const file = acceptedFiles[0];

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        // Preview Image
        if (id === "logo") {
          setLogo(reader.result);
        }
      };
    }
  }, []);

  useEffect(() => {
    form_data.store_logo = logo;
    setFormData(form_data);
  }, [logo]);

  const onDropRejected = useCallback(() => {
    setAlert("Image file smaller than 5mb only.", "error");
  }, []);

  const dropzone = (label, id, url) => {
    return (
      <Dropzone
        accept="image/*"
        multiple={false}
        onDrop={(e) => onDrop(e, id)}
        onDropRejected={() => onDropRejected()}
        maxSize={5242880}
      >
        {({ getRootProps, getInputProps }) => (
          <Grid item xs={6} className={classes.inputBox}>
            <InputLabel shrink required className={classes.input}>
              {label} &nbsp;
              {id === "logo" && (
                <Tooltip
                  placement="top-start"
                  title={
                    <div className={classes.helper}>
                      Crop the logo image to fit the box if necessary.
                    </div>
                  }
                >
                  <HelpOutline fontSize="medium" color="error" />
                </Tooltip>
              )}
            </InputLabel>
            <Grid
              id={id}
              item
              container
              className={clsx({
                [classes.dropzone]: true,
                [classes.dropzoneHover]: true,
                [classes.dropzoneError]: form_data.store_logo && !url,
              })}
              {...getRootProps()}
            >
              <input id={id} {...getInputProps()} />
              {url ? (
                <img
                  height="110"
                  width="100%"
                  src={url}
                  className={classes.image}
                  alt=""
                />
              ) : (
                <span>
                  <CloudUpload />
                  <Typography variant="body2">
                    Drag and drop file here or click to select file
                  </Typography>
                </span>
              )}
            </Grid>
          </Grid>
        )}
      </Dropzone>
    );
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="caption" color="primary">
          Step 4: Store Details
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        spacing={2}
        container
        alignItems="flex-start"
        justifyContent="flex-start"
      >
        <Grid item xs={6}>
          <TextField
            fullWidth
            size="small"
            margin="dense"
            variant="outlined"
            label="Store name"
            id="store_name"
            name="store_name"
            onChange={handleChange}
            value={form_data.store_name}
          />
        </Grid>
      </Grid>

      <Fragment>
        <Grid item xs={12}>
          <FormHelperText margin="dense">
            * Drag and drop or click on image to <strong> replace </strong>
            preview image(s). <br />
          </FormHelperText>
        </Grid>
        {dropzone("Store logo", "logo", form_data.store_logo)}
      </Fragment>
    </Grid>
  );
};

export default Section_04;
